import ViewerMethod from "../../core/ViewerMethod";
import { createViewerAction } from "../../core/make-action";
import { Action } from "redux";

export const searchContent = createViewerAction(
  ViewerMethod.SEARCH_BOOK_CONTENT
);
export const goToSearchResults = createViewerAction(
  ViewerMethod.GO_TO_SEARCH_RESULT
);
export const highlightSearchTerm = createViewerAction(
  ViewerMethod.HIGHLIGHT_SEARCH_RESULTS
);

export const unhighlightSearchTerm = createViewerAction(
  ViewerMethod.UNHIGHLIGHT_SEARCH_RESULTS
);

export const SEARCH_ADD_RECENT = "searchAddRecent";

export interface SearchAddRecentAction extends Action {
  type: typeof SEARCH_ADD_RECENT;
  query: string;
}
export const searchAddRecent = (query: string): SearchAddRecentAction => {
  return { type: SEARCH_ADD_RECENT, query };
};

export type SearchAction = SearchAddRecentAction;
